// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".read[data-v-5da60057]{opacity:.5}.time[data-v-5da60057]{color:grey;font-size:14px}", ""]);
// Exports
module.exports = exports;
